<template>
  <nav class="sidebar sidebar-full gate-sidebar unselectable" :aria-label="$t('app.section')">
    <div class="sidebar_body">
      <router-link
        v-for="item in items"
        :key="item.name"
        :to="{ name: item.name }"
        class="flex items-center sidebar_item mb-05"
        :class="{ sidebar_item_selected: isActive(item) }"
      >
        <el-icon class="gate-sidebar__icon"><component :is="item.icon" /></el-icon>
        <span class="text-body fw-500 ml-05">{{ $t(item.label) }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { Checked, Document, User } from '@element-plus/icons-vue'

/**
 * Разделы кабинета контрагента. Карточка документа подсвечивает «В работе» — оттуда в неё
 * приходят чаще всего, а отдельного пункта у неё нет.
 */
const items = [
  { name: 'in-work', label: 'sidebar.in_work', icon: Document, also: ['cabinet-documents-item'] },
  { name: 'reviewed-documents', label: 'sidebar.reviewed', icon: Checked },
  { name: 'reviewer-list', label: 'sidebar.reviewers', icon: User },
]

const route = useRoute()
const isActive = (item) => route.name === item.name || (item.also ?? []).includes(route.name)
</script>

<style scoped lang="scss">
@use '@/assets/styles/base/variables' as *;

.gate-sidebar {
  left: 0;
  z-index: 10;
  color: $color-slate-600;

  .sidebar_item {
    color: $color-slate-600;
    text-decoration: none;
    min-height: 40px;
    box-sizing: border-box;
  }

  .sidebar_item:focus-visible {
    outline: 2px solid $color-tiffany-500;
    outline-offset: 2px;
  }

  &__icon {
    font-size: 20px;
    color: $color-slate-400;
  }
}
</style>
